module.exports = __webpack_public_path__ + "static/media/onlinetimeandattendance.bfe4887f.webp";